function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypingAnimation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    className: "loader",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 10,
    cy: 20,
    r: 3,
    style: {
      fill: "grey"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 20,
    cy: 20,
    r: 3,
    style: {
      fill: "grey"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 30,
    cy: 20,
    r: 3,
    style: {
      fill: "grey"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypingAnimation);
export default __webpack_public_path__ + "static/media/typing-animation.4be3f4f1.svg";
export { ForwardRef as ReactComponent };